import React from 'react'

const HelpCentreIcon = (
  <>
    <path
      d="M61.816 11.6H66.2V34H61.816V24.72H53.496V34H49.08V11.6H53.496V20.496H61.816V11.6ZM73.6573 27.696C74.2333 29.808 75.9933 30.704 78.1693 30.704C79.7693 30.704 81.0493 30.032 81.7533 29.104L85.0813 31.024C83.5773 33.2 81.1773 34.448 78.1053 34.448C72.7293 34.448 69.3372 30.768 69.3372 26C69.3372 21.232 72.7613 17.552 77.7853 17.552C82.5213 17.552 85.8813 21.296 85.8813 26C85.8813 26.608 85.8173 27.152 85.7213 27.696H73.6573ZM73.5933 24.496H81.7533C81.2413 22.192 79.5133 21.264 77.7853 21.264C75.5773 21.264 74.0733 22.448 73.5933 24.496ZM88.763 34V10.64H92.891V34H88.763ZM105.981 17.552C110.269 17.552 113.789 21.232 113.789 26C113.789 30.768 110.269 34.448 105.981 34.448C103.645 34.448 101.949 33.584 100.797 32.112V40.4H96.6693V18H100.797V19.888C101.949 18.416 103.645 17.552 105.981 17.552ZM105.213 30.512C107.773 30.512 109.661 28.688 109.661 26C109.661 23.312 107.773 21.488 105.213 21.488C102.685 21.488 100.797 23.312 100.797 26C100.797 28.688 102.685 30.512 105.213 30.512ZM135.517 34.448C128.733 34.448 123.868 29.328 123.868 22.8C123.868 16.24 128.733 11.152 135.517 11.152C139.613 11.152 143.229 13.232 145.149 16.432L141.341 18.64C140.253 16.656 138.077 15.44 135.517 15.44C131.133 15.44 128.253 18.48 128.253 22.8C128.253 27.088 131.133 30.128 135.517 30.128C138.077 30.128 140.285 28.912 141.341 26.96L145.149 29.168C143.261 32.368 139.645 34.448 135.517 34.448ZM151.251 27.696C151.827 29.808 153.587 30.704 155.763 30.704C157.363 30.704 158.643 30.032 159.347 29.104L162.675 31.024C161.171 33.2 158.771 34.448 155.699 34.448C150.323 34.448 146.931 30.768 146.931 26C146.931 21.232 150.355 17.552 155.379 17.552C160.115 17.552 163.475 21.296 163.475 26C163.475 26.608 163.411 27.152 163.315 27.696H151.251ZM151.187 24.496H159.347C158.835 22.192 157.107 21.264 155.379 21.264C153.171 21.264 151.667 22.448 151.187 24.496ZM175.253 17.552C178.645 17.552 181.301 19.92 181.301 24.176V34H177.173V24.688C177.173 22.512 175.861 21.392 174.005 21.392C171.989 21.392 170.485 22.576 170.485 25.36V34H166.357V18H170.485V19.792C171.445 18.352 173.109 17.552 175.253 17.552ZM193.978 21.968H190.362V28.624C190.362 30.352 191.61 30.384 193.978 30.256V34C188.186 34.64 186.234 32.944 186.234 28.624V21.968H183.45V18H186.234V14.768L190.362 13.52V18H193.978V21.968ZM201.266 20.752C202.098 18.576 204.114 17.68 206.13 17.68V22.288C203.986 22.032 201.266 22.992 201.266 26.352V34H197.138V18H201.266V20.752ZM211.439 27.696C212.015 29.808 213.775 30.704 215.951 30.704C217.551 30.704 218.831 30.032 219.535 29.104L222.863 31.024C221.359 33.2 218.959 34.448 215.887 34.448C210.511 34.448 207.118 30.768 207.118 26C207.118 21.232 210.543 17.552 215.567 17.552C220.303 17.552 223.663 21.296 223.663 26C223.663 26.608 223.599 27.152 223.503 27.696H211.439ZM211.375 24.496H219.535C219.023 22.192 217.295 21.264 215.567 21.264C213.359 21.264 211.855 22.448 211.375 24.496Z"
      fill="#704D94"
    />
    <g clipPath="url(#clip0_2212_31693)">
      <path
        d="M11.1306 11.2799C11.1306 12.1332 11.1573 12.9866 11.2107 13.8132C12.4454 14.5384 13.5176 15.5096 14.3604 16.6666C19.859 23.7332 22.0477 36.9066 22.0477 36.9066C22.0477 36.9066 29.8953 22.3466 29.8953 11.2799C29.8953 -3.49342 11.1306 -4.02676 11.1306 11.2799Z"
        fill="url(#paint0_linear_2212_31693)"
      />
      <path
        d="M11.2108 13.8134C4.13732 9.65338 -4.16397 17.4667 2.37563 25.9201C10.3566 36.2134 22.0478 36.9067 22.0478 36.9067C22.0478 36.9067 12.2785 28.3734 11.2108 13.8134Z"
        fill="url(#paint1_linear_2212_31693)"
      />
      <path
        d="M11.2107 13.8135C12.2784 28.3735 22.0478 36.9068 22.0478 36.9068C22.0478 36.9068 19.859 23.7335 14.3604 16.6668C13.5176 15.5099 12.4454 14.5386 11.2107 13.8135Z"
        fill="url(#paint2_linear_2212_31693)"
      />
      <path
        d="M11.2107 13.8135C12.2784 28.3735 22.0478 36.9068 22.0478 36.9068C22.0478 36.9068 19.859 23.7335 14.3604 16.6668C13.5176 15.5099 12.4454 14.5386 11.2107 13.8135Z"
        fill="#F0007E"
      />
      <path
        d="M36.5152 28.0795C35.5378 29.1115 34.3576 29.9308 33.0486 30.486C31.7396 31.0412 30.3299 31.3205 28.9079 31.3062C28.8156 29.8846 29.0189 28.4594 29.505 27.1202C29.9911 25.781 30.7495 24.5568 31.7324 23.5247C32.7153 22.4927 33.9014 21.6751 35.2161 21.1235C36.5307 20.5719 37.9455 20.2981 39.3712 20.3195C39.4596 21.7401 39.2514 23.1636 38.7597 24.4994C38.268 25.8353 37.5037 27.0545 36.5152 28.0795Z"
        fill="url(#paint3_linear_2212_31693)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2212_31693"
        x1="10.0175"
        y1="33.3999"
        x2="27.3906"
        y2="3.50009"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF0099" />
        <stop offset="1" stopColor="#FFCC00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2212_31693"
        x1="8.14383"
        y1="32.312"
        x2="25.5169"
        y2="2.41223"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF0099" />
        <stop offset="1" stopColor="#FFCC00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2212_31693"
        x1="11.4696"
        y1="34.2455"
        x2="28.8427"
        y2="4.34566"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF0099" />
        <stop offset="1" stopColor="#FFCC00" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2212_31693"
        x1="24.7332"
        y1="41.9489"
        x2="42.1063"
        y2="12.0517"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF0099" />
        <stop offset="1" stopColor="#FFCC00" />
      </linearGradient>
      <clipPath id="clip0_2212_31693">
        <rect width="39" height="40" fill="white" />
      </clipPath>
    </defs>
  </>
)

export default HelpCentreIcon
